<template>
  <div class="container mb-5">
    <v-data-table
      :headers="headers"
      :search="search"
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :server-items-length="totalItems"
      class="elevation-1 mt-5"
    >
      <template v-slot:top>
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              label="Search Indentity Number"
              class="mx-4 col-12 col-lg-12"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn class="mx-4" depressed color="primary" @click="searchBtn">
              Search
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <detail-view-b2b :detail="item"></detail-view-b2b>
      </template>
      <template v-slot:[`item.StatusEnq`]="{ item }">
        <v-chip :color="getColor(item.StatusEnq)" dark>
          {{ item.StatusEnq == 1 ? "Match" : "No Match" }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

 
<script>
import axios from "axios";
import DetailViewB2b from "./components/DetailViewB2b.vue";
export default {
  components: { DetailViewB2b },
  name: "ListAppEnqB2b",

  data: () => ({
    dialogDetail: false,
    search: "",
    totalItems: 0,
    page: 1,
    itemsPerPage: 5,
    headers: [
      {
        text: "Actions",
        value: "actions",
        sortable: false,
      },
      { text: "Status Enq", value: "StatusEnq", sortable: false },
      { text: "Reference Number", value: "IdMessage" },
      { text: "Business Identity Number", value: "BusinessIdentityNumber" },
      { text: "Trade Name", value: "TradeName" },
      { text: "Created At", value: "created_at" },
    ],
    items: [],
    dataDetail: "",
  }),

  created() {
    this.getListNewAppEnqB2b(1, 5);
  },

  watch: {
    page: function (val) {
      this.getListNewAppEnqB2b(val, this.itemsPerPage);
    },
    itemsPerPage: function (val) {
      if (val == -1) {
        this.getListNewAppEnqB2b(1, this.totalItems);
      } else {
        this.getListNewAppEnqB2b(this.page, val);
      }
    },
  },

  methods: {
    getColor(status) {
      if (status == 0) {
        return "red";
      } else {
        return "green";
      }
    },

    async getListNewAppEnqB2b(pageNumber, pageSize) {
      // axios.get('http://127.0.0.1:8000/api/newapp').then(res => {
      //   this.items = res.data;
      // })
      let params = { "page[number]": pageNumber, "page[size]": pageSize };
      await this.$store.dispatch("finance_click_b2b/list", params);

      if (
        (await this.$store.getters["finance_click_b2b/list"]) &&
        (await this.$store.getters["finance_click_b2b/list"].length) != 0
      ) {
        this.items = await this.$store.getters["finance_click_b2b/list"];
        this.totalItems = await this.$store.getters[
          "finance_click_b2b/listTotal"
        ];
      }

      // console.log("LIST_NEW_APP_B2B", this.items);
    },

    async searchBtn() {
      if (this.search !== "") {
        let params = { "filter[business_identity_number]": this.search };
        await this.$store.dispatch("finance_click_b2b/list", params);

        this.items = await this.$store.getters["finance_click_b2b/list"];
        this.totalItems = await this.$store.getters[
          "finance_click_b2b/listTotal"
        ];
      } else {
        this.getListNewAppEnqB2b(this.page, this.itemsPerPage);
      }
    },

    getLastDate() {
      return this.items[0].created_at;
    },
  },
};
</script>